import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import moment from 'moment-timezone';

@Directive({
    selector: '[daysAfter][formControlName][dayCount],[daysAfter][formControl][dayCount],[daysAfter][ngModel][dayCount]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DaysAfterValidatorDirective),
            multi: true,
        },
    ],
})
export class DaysAfterValidatorDirective implements Validator
{
    @Input()
    public daysAfter: {
        days: number,
        after: string
    };

    validate(thisControl: AbstractControl): { [key: string]: any } {
        const thisControlValue = thisControl.value;

        let thatControl: any = false;
        let thatControlValue = null;
        if (this.daysAfter.after === 'today') {
            thatControlValue = moment.utc();
        } else {
            thatControl = thisControl.root.get(this.daysAfter.after);
            if (thatControl) {
                thatControlValue = thatControl.value;
            }
        }

        if (moment.isMoment(thisControlValue) && moment.isMoment(thatControlValue)) {
            const comparisonDate = thatControlValue.clone().add(this.daysAfter.days, 'day');
            if (!thisControlValue.isSameOrAfter(comparisonDate, 'day')) {
                const dateInterval = this.daysAfter.days === 1 ? 'day' : 'days';
                return {
                    insufficientDayBuffer: 'Value must be at least ' + this.daysAfter.days + ' ' + dateInterval + ' after ' + this.daysAfter + '.',
                };
            }
        }

        return null;
    }
}
